<template>
  <a class="coffeeList__row" :href="item.url" data-aos="fade-up">
    <ul>
      <li class="coffeeList__cell" :data-th="lang.country">{{ item.country }}</li>
      <li class="coffeeList__cell">{{ item.title }}</li>
      <li class="coffeeList__cell" :data-th="lang.price2">{{ item.price }}</li>
      <li class="coffeeList__cell" :data-th="lang.reserve"><i class="icon-check" v-if="parseInt(item.reserve) === 1"></i></li>
    </ul>
  </a>
</template>

<script>
export default {
  name: "row",
  props: [
    'item',
    'lang'
  ],
}
</script>
